import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, TextField } from '@mui/material';

const AdditionalInformationInput = ({ value, onChange }) => {
  return (
    <Box sx={{ p: 2, bgcolor: 'grey.50' }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Additional Information (Optional)
      </Typography>

      <TextField
        fullWidth
        multiline
        minRows={6}
        placeholder="Enter any specific notes or context for this month's report to be included in the email body..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          bgcolor: 'background.paper',
          '& .MuiOutlinedInput-root': {},
        }}
      />
    </Box>
  );
};

AdditionalInformationInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default AdditionalInformationInput;
